
import { getConfig, isBank } from '@/config/core';
import { ENTRY_POINT } from '@/types/entryPoints';
import { getHostByRegion } from '../getSuffix';

export const isSaasEntryPoint = (): boolean => {
  const { entryPoint } = getConfig();
  return [ENTRY_POINT.ShopeeAPPFoodVNHC, ENTRY_POINT.ShopeeFoodVNAppHC, ENTRY_POINT.ShopeeFoodVNDriverHC].includes(entryPoint as unknown as ENTRY_POINT);
};

export const isFood = (): boolean => {
  const { entryPoint } = getConfig();
  return [ENTRY_POINT.ShopeeAPPFoodVNHC, ENTRY_POINT.ShopeeFoodVNAppHC, ENTRY_POINT.ShopeeFoodVNDriverHC].includes(entryPoint as unknown as ENTRY_POINT);
};


export function getLiveChatApiDomain(): string {
  const { entryPoint }: any = getConfig();
  if (entryPoint === ENTRY_POINT.ShopeeAPPFoodVNHC || entryPoint === ENTRY_POINT.ShopeeFoodVNAppHC || entryPoint === ENTRY_POINT.ShopeeFoodVNDriverHC) {
    return `shopeefood.chatbot.${getHostByRegion(COUNTRY, 'shopee', ENVIRONMENT)}`;
  } else {
    return `chatbot.${getHostByRegion(COUNTRY, isBank() ? 'seabank' : 'shopee', ENVIRONMENT)}`;
  }
}

// UserSessionRequestUrl由于是chatbot BE从服务端请求，在bank nolive环境不支持公网域名，所以改为内网域名
export function getUserSessionRequestUrl(): string {
  const { entryPoint } = getConfig();
  const domainMap: any = {
    'development': { default: `https://${getLiveChatApiDomain()}/chat/v1/user_session` },
    'test': { default: `https://${getLiveChatApiDomain()}/chat/v1/user_session` },
    'uat': {
      [ENTRY_POINT.BankHelpCenter]: 'http://ph-cschannel-api-uat-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankMePage]: 'http://ph-cschannel-api-uat-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankIDHelpCenter]: 'http://id-cschannel-api-uat-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankIDMePage]: 'http://id-cschannel-api-uat-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankSGHelpCenter]: 'http://cschannel-api-uat-ext.biz.maribanksvc.com/userchat/v1/user_session',
      [ENTRY_POINT.BankSGMePage]: 'http://cschannel-api-uat-ext.biz.maribanksvc.com/userchat/v1/user_session',
      default: `https://${getLiveChatApiDomain()}/chat/v1/user_session`,
    },
    'live': {
      [ENTRY_POINT.BankHelpCenter]: 'http://cschannel-api-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankMePage]: 'http://cschannel-api-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankIDHelpCenter]: 'http://cschannel-api-ext.biz.seabanksvc.com/chat/v1/user_session',
      [ENTRY_POINT.BankIDMePage]: 'http://cschannel-api-ext.biz.seabanksvc.com/chat/v1/user_session',
      default: `https://${getLiveChatApiDomain()}/chat/v1/user_session`,
    },
  }[ENVIRONMENT];
  return (domainMap as any)[entryPoint] || domainMap.default;
}

